var _defs, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _path8, _path9, _circle, _circle2, _path10, _path11, _ellipse2, _path12, _path13, _path14, _path15, _path16, _ellipse3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.424 1.46a15.5 15.5 0 0 0-15.5 15.5 84.466 84.466 0 0 0 2 18.5s11 2 18.5-1 10.5-7.5 10.5-7.5v-10a15.5 15.5 0 0 0-15.5-15.5z",
    fill: "#ffcc24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.424 1.46a15.5 15.5 0 0 0-15.5 15.5c0 .891.018 1.755.045 2.607a15.49 15.49 0 0 1 30.955.893v-3.5a15.5 15.5 0 0 0-15.5-15.5z",
    fill: "#ffdd7d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.424 1.46a15.5 15.5 0 0 0-15.5 15.5 84.466 84.466 0 0 0 2 18.5s11 2 18.5-1 10.5-7.5 10.5-7.5v-10a15.5 15.5 0 0 0-15.5-15.5z",
    stroke: "#45413c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25px",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.924 40.96c0-8.008-4.477-14.5-10-14.5s-10 6.492-10 14.5c0 7 4.5 7.5 6.5 7.5s6 .064 6 0h5.5a2.006 2.006 0 0 0 2-2z",
    fill: "#ff6196"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.827 34.963a15.461 15.461 0 0 0 17.58-1.655c-1.766-4.106-4.9-6.848-8.483-6.848-4.046 0-7.524 3.492-9.097 8.503z",
    fill: "#e0366f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.924 40.96c0-8.008-4.477-14.5-10-14.5s-10 6.492-10 14.5c0 7 4.5 7.5 6.5 7.5s6 .064 6 0h5.5a2.006 2.006 0 0 0 2-2z",
    stroke: "#45413c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25px",
    fill: "none"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.856,
    cy: 40.692,
    rx: 9.107,
    ry: 7.056,
    transform: "rotate(-36.61 26.855 40.692)",
    fill: "#ffffff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.166 35.261c-2.18-2.935-6.854-3.208-10.758-.753a10.18 10.18 0 0 0 10.8 8.256c1.4-2.572 1.492-5.438-.042-7.503z",
    fill: "#f0f0f0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.424 15.96a26.077 26.077 0 0 1-12.5-1.5s-1 7.5-7 10v5.454a15.48 15.48 0 0 0 19.5-2.037z",
    fill: "#ffe500"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.424 15.96a26.077 26.077 0 0 1-12.5-1.5s-1 7.5-7 10v5.454a15.48 15.48 0 0 0 19.5-2.037z",
    stroke: "#45413c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25px",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.384,
    cy: 21.58,
    r: 0.876,
    fill: "#45413c"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.632,
    cy: 19.816,
    r: 0.876,
    fill: "#45413c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.375 24.533a1.914 1.914 0 0 0 2.035.541 2.161 2.161 0 0 0 1.283-1.67m-4.065 14.819c.613 2.926 2.616 7.777 8.074 9",
    stroke: "#45413c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25px",
    fill: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m20.672 36.887.752 1.073s3.5 5 12 6",
    stroke: "#45413c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25px",
    fill: "none"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.856,
    cy: 40.692,
    rx: 9.107,
    ry: 7.056,
    transform: "rotate(-36.61 26.855 40.692)",
    stroke: "#45413c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25px",
    fill: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.924 40.96c0 7 4.5 7.5 6.5 7.5s4.5-1 4.5-3-2-3-4.5-3h-3.5",
    fill: "#ff6196",
    stroke: "#45413c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25px"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.924 42.486v5.952c1.893-.151 4-1.141 4-2.978 0-1.86-1.742-2.846-4-2.974z",
    fill: "#ffe500",
    stroke: "#45413c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25px"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.157 34.871a1.828 1.828 0 0 0-.216-.11 8.49 8.49 0 0 0-13.9-8.926 1.761 1.761 0 0 0-.189-.151 2 2 0 0 0-2.161 3.366 2.066 2.066 0 0 0 .215.109 8.491 8.491 0 0 0 13.9 8.927 1.975 1.975 0 0 0 .189.15 2 2 0 1 0 2.162-3.365z",
    fill: "#ffe500"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.38 32.754a10.721 10.721 0 0 0-16.629-3.107q.07-.246.155-.49a1.887 1.887 0 0 1-.215-.109 2 2 0 0 1 2.161-3.366 1.9 1.9 0 0 1 .189.151 8.489 8.489 0 0 1 14.339 6.921",
    fill: "#fff48c"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.157 34.869a1.681 1.681 0 0 0-.216-.109 8.49 8.49 0 0 0-13.9-8.927 1.9 1.9 0 0 0-.189-.151 2 2 0 0 0-2.161 3.366 1.887 1.887 0 0 0 .215.109 8.491 8.491 0 0 0 13.9 8.927 1.975 1.975 0 0 0 .189.15 2 2 0 1 0 2.162-3.365z",
    stroke: "#45413c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25px",
    fill: "none"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.673,
    cy: 41.452,
    rx: 2.952,
    ry: 2.269,
    transform: "rotate(-32.858 34.674 41.452)",
    fill: "#ffe500",
    stroke: "#45413c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25px"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMom);
export default __webpack_public_path__ + "static/media/mom.b7bcbdd639f6c678c19bda6cb82a850a.svg";
export { ForwardRef as ReactComponent };